
@defer (when !isLoading()) {
	<p> Loaded Product Card!!</p>
} @placeholder {
	<plp-components-skeleton-compare-grid-product-card
		[isCompact]="isCompact()">
	</plp-components-skeleton-compare-grid-product-card>
}
